var map = {
	"./TsBreadcrumb": "b750",
	"./TsButton": "7e4d",
	"./TsCard": "2084",
	"./TsCardWrapper": "68e7",
	"./TsCheckbox": "3b02",
	"./TsDatePickerInput": "57ad",
	"./TsImageInput": "16a7",
	"./TsInput": "6b4cb",
	"./TsPagination": "1751",
	"./TsSearchSelect": "1f9c",
	"./TsSelect": "8362",
	"./TsTab": "8e19",
	"./TsTable": "5ca3",
	"./TsTextarea": "7730",
	"./TsTimePickerInput": "6b8b",
	"./TsWaiting": "d2f9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "140b";